require('./Components/Toast');

import * as Hvd from './Hvd';
import * as RW from './ReportWesen';
import * as Components from './Components';
import * as Cms from './Cms';
import { DeleteImportFiles } from './Hvd/DeleteImportFiles';

let loaded = new Array();

document.addEventListener('DOMContentLoaded', function () {
    let bodyFiles = [];
    document.querySelectorAll('script[data-src], link[data-href]').forEach( (el : HTMLElement) => {
        bodyFiles.push(el.dataset.src ? el.dataset.src : el.dataset.href );
        el.remove();
    });
    bodyFiles.forEach(async (file, index) => {
        await addFiles(file);
        while (!wait(file)) {}
        if (index === bodyFiles.length - 1) {
            await loadScript();
            // window.setTimeout(init, 100);
            // await init();
        }
    });

    var bodyClass = document.cookie.match(/bodyClass=([^;]*)/);
    if (bodyClass?.length >= 2) {
        document.getElementsByTagName('body')[0].className = bodyClass[1];
    }


});

window.onload = () => {
    init();
}

async function loadScript() {
    if(document.querySelectorAll('*:not(.no-edit).ckedit').length) {
        let file ='/js/edit.min.js';
        if(location.host.match(/ddev/)) {
            file ='/js/edit.js';
        }
        await addFiles(file);
        while (!wait(file)) {}
    }
}

async function wait(file: string, counter: number = 1000) {
    if (counter > 0 && !loaded.includes(file)) {
        setTimeout(wait, 800, file, counter--);
        return false;
    } else {
        return true;
    }
}

async function init() {
    new Cms.Quickfind();
    new Components.Accordion();

    document.querySelectorAll('.js-pegel-detail-warn').forEach( async (container:HTMLElement) => {
        new Components.DetailWarn(container);
    });
    document.querySelectorAll('.js-talsperre-info-control').forEach( async (container:HTMLElement) => {
        new Components.TalsperreControl(container);
    });
    document.querySelectorAll('.js-talsperre-user-control').forEach( async (container:HTMLElement) => {
        // Frontend-bearbeitung
        new Components.TalsperreControl(container);
    });
    window.addEventListener('ckedit-drop', async (ev: CustomEvent) => {
        // console.log(ev.detail.item);
        if ($(ev.detail.item).find('.js-talsperre-info-control').length) {
            new Components.TalsperreControl($(ev.detail.item).find('.js-talsperre-info-control')[0]);
        }
        if ($(ev.detail.item).find('.js-pegel-detail-warn').length) {
            new Components.DetailWarn($(ev.detail.item).find('.js-pegel-detail-warn')[0]);
        }
        if (ev.detail.item[0].querySelectorAll('.js-linklist-container').length) {
            new Components.LinkList(ev.detail.item[0].querySelector('.js-linklist-container'));
        }

    });
    new Cms.MapState();
    new Cms.MultiDiagram();
    new Components.BarAccordion();
    new RW.Reportwesen();
    new Components.Tabs();
    new Hvd.Redirect();
    new Hvd.CKEditor();
    new Hvd.Notes();
    new Hvd.DiagramArea();
    new Hvd.EditTalsperreControl();
    new Components.ListColHeight('.list>.row');
    new Components.WeatherTabs();
    new Hvd.Slave();
    new Components.ToggleButton();
    new Hvd.User();
    new Components.ConstructionStation();
    new Cms.DiaShow();
    new Hvd.Text();
    document.querySelectorAll('.js-linklist-container').forEach( (container:HTMLElement) => {
        new Components.LinkList(container);
    });

    new Components.FilterList();
    new DeleteImportFiles();
}

async function addFiles(file: string) {
    let header = document.querySelector('head');
    if (/\.css/.test(file)) {
        const addStyle = document.createElement('link');
        addStyle.href = file;
        addStyle.rel = 'stylesheet';
        addStyle.type = 'text/css';
        addStyle.addEventListener('load', (ev) => {
            loaded.push(file);
        });
        header.insertAdjacentElement('beforeend',addStyle);
    } else {
        const addJs = document.createElement('script');
        addJs.src = file;
        addJs.addEventListener('load', (ev) => {
            loaded.push(file);
        });
        header.insertAdjacentElement('beforeend',addJs);
    }
}
